{
  "limits": {
    "overlay": {
      "title": {
        "customColoursOnModels": "Colores personalizados en modelos"
      },
      "content": {
        "text1": {
          "customColoursOnModels": "Actualmente no tiene acceso para agregar colores personalizados a sus modelos 3D. Actualízate para trabajar en los planes en colaboración con otros miembros del equipo.",
          "customSharedPlanExpiryDuration": "Actualiza para establecer duraciones de caducidad personalizadas para los enlaces compartidos."
        }
      }
    }
  }
}